import { render, staticRenderFns } from "./ModalEmailAuthentication.vue?vue&type=template&id=f2a85cea&scoped=true&"
import script from "./ModalEmailAuthentication.vue?vue&type=script&lang=js&"
export * from "./ModalEmailAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmailAuthentication.vue?vue&type=style&index=0&id=f2a85cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a85cea",
  null
  
)

export default component.exports